import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import Button from '../../Button/Button.js';
import '../../Button/SplitButton.js';

const StyledButton = styled(Button)({
    minWidth: 30,
});
/**
 * A button styled to be placed above the grid or inside a row. Can be used by consumers of DataGrid.
 */
const DataGridControlButton = (_a) => {
    var buttonProps = __rest(_a, []);
    const onClick = e => {
        var _a;
        // This is useful when using DataGridControlButton as part of the inline RowMenu
        e.stopPropagation();
        (_a = buttonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(buttonProps, e);
    };
    return jsx(StyledButton, Object.assign({ variant: "muted" }, buttonProps, { onClick: onClick }));
};

export { DataGridControlButton as default };
//# sourceMappingURL=DataGridControlButton.js.map
